import { render, staticRenderFns } from "./SelectionModal.vue?vue&type=template&id=70267801&scoped=true&"
import script from "./SelectionModal.vue?vue&type=script&lang=js&"
export * from "./SelectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70267801",
  null
  
)

export default component.exports